import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {Link, useSearchParams} from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";

import { REQUIRED_FIELDS } from "../../utils/variables";
import { validateFieldAfterLogin } from "../../utils/helperValidations";
import { useFormStore } from "../../store/useFormStore";
import { fetchRegisterUser } from "../../api/registerApi";
import { ProviderSignupForm } from "./ProviderSignupForm";

export function ProviderSignupPage() {
  const { t, i18n } = useTranslation();

  const [category, setCategory] = useState("provider");
  const [describe, setDescribe] = useState({});

  const [step, setStep] = useState("stap2");
  const [showModal, setShowModal] = useState(false);
  const [isSelect, setIsSelect] = useState("");

  const [latLong, setLatLong] = useState({});
  const [contactCode, setContactCode] = useState({
    code: "",
    flag: "",
  });
  const [code, setCode] = useState(true);

  const {
    formLogin,
      errorField,
    setFormLogin,
    setErrorField,
    resetFormLogin,
    resetErrorField,
  } = useFormStore();

  useEffect(() => {
    return () => {
      resetFormLogin();
      resetErrorField();
    };
  }, []);

  const today = new Date();

  const handleCodeSelect = () => {
    if (code) {
      setCode(false);
    } else {
      setCode(true);
    }
  };

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => {
    setFormLogin({ ...formLogin, dob: "" });
    setShowModal(true);
  };

  const [searchParams] = useSearchParams();
  const isDevMode = searchParams.get('dev');

  const handleSignup = async () => {
    const isFormValid = [
      formLogin.username,
      formLogin.email,
      formLogin.password,
      formLogin.c_password,
      formLogin.first_last_name,
      formLogin.dob,
      formLogin.address,
      formLogin.zip,
      formLogin.hearAboutUs,
    ].every((field) => field !== "");

    if (isFormValid && errorField.first_last_name === "") {
      try {
        const result = await fetchRegisterUser(
          formLogin,
          contactCode,
          category,
          describe,
          i18n.language,
            latLong
        );

        if (result.errors) {
          const { email, username } = result.errors.error;
          setErrorField({
            email: email ? t("The email has already been taken.") : "",
            username: username ? "The username has already been taken." : "",
            first_name: "",
          });
        }

        if (result.success) {
          window.location.href =
              category === "parents"
                  ? "/parent_thankyou"
                  : "/providers_thankyou";
        }
      } catch (error) {
        console.error("Error registering user:", error);

      if (error.toString().includes("The email has already been taken.")) {
        setErrorField((prevErrors) => ({
          ...prevErrors,
          email: t("The email has already been taken."),
        }));
      }

      if (error.toString().includes("The username has already been taken.")) {
        setErrorField((prevErrors) => ({
          ...prevErrors,
          username: t("The username has already been taken."),
        }));
      }
      }
    } else {
      REQUIRED_FIELDS.forEach((el) => validateAfterLoginField(el));
    }
  };

  const validateAfterLoginField = (name) => {
    const error = validateFieldAfterLogin(name, formLogin, contactCode, t);

    setErrorField((prevErrorField) => ({
      ...prevErrorField,
      [name]: error,
    }));
  };

  const handleDescribeSelect = (a, b) => {
    if (Object.keys(describe).length < 2) {
      setDescribe({ ...describe, [a]: b });
    } else {
      delete describe[a];
      setDescribe({ ...describe });
    }
  };

  const handleRedirect = () => {
    const currentSearch = window.location.search; // gets ?dev=true or other params
    window.location.href = "/signup" + currentSearch;
  };

   /*if (isDevMode !== 'true') {
     return (
         <div className="container-fluid">
           <div className="container">
             <div className="signup_section">
               <div className="more_about provider">
                 <h2>{t("Maintenance Mode")}</h2>
                 <p>{t("This page is currently in work.")}</p>
               </div>
             </div>
           </div>
         </div>
     );
   }*/

  return (
    <>
      <div className="container-fluid">
        <div className="container">
          <div className="signup_section">
            <div className="header_sign">
              <ul>
                <li>
                  <Link to="/">
                    <img src="./images/left_arrow.svg" />
                    <span>{t("Home")}</span>
                  </Link>
                </li>
                <li className="login">
                  <span>{t("Already a member?")}</span>
                  <Link to="/login">{t("log-in")} </Link>
                </li>
              </ul>
            </div>

                  <div
                      className={
                          "describe more_about " + (step == "stap2" ? "" : "none")
                      }
                  >
                    <img src="/images/sign_logo.svg" />
                    <h2>{t("What describes you best")}</h2>
                    <p>
                      <span>{t("I am")} </span> (
                      {t("Please select up to two professions")}) <br />
                      {t("signup-change-choice")}
                    </p>
                    <div className="process_guid ">
                      <ul>
                        <li
                            className={
                              describe && describe.tab1 == t("text-nanny")
                                  ? "active"
                                  : "" + isSelect == ""
                                      ? ""
                                      : "bordererror"
                            }
                            onClick={(e) => {
                              handleDescribeSelect("tab1", t("text-nanny"));
                              setIsSelect("");
                            }}
                        >
                          <div>
                            <img
                                src={
                                  describe && describe.tab1 == t("text-nanny")
                                      ? "./images/nanny_fill.svg"
                                      : "./images/nanny.svg"
                                }
                            />
                            <span>{t("text-nanny")}</span>
                          </div>
                        </li>
                        <li
                            className={
                              describe && describe.tab2 == t("education-teacher")
                                  ? "active"
                                  : "" + isSelect == ""
                                      ? ""
                                      : "bordererror"
                            }
                            onClick={(e) => {
                              handleDescribeSelect("tab2", t("education-teacher"));
                              setIsSelect("");
                            }}
                        >
                          <div>
                            <img
                                src={
                                  describe && describe.tab2 == t("education-teacher")
                                      ? "./images/teacher_fill.svg"
                                      : "./images/teacher.svg"
                                }
                            />
                            <span>{t("education-teacher")}</span>
                          </div>
                        </li>
                        <li
                            className={
                              describe &&
                              describe.tab3 == t("education-paraprofessional")
                                  ? "active"
                                  : "" + isSelect == ""
                                      ? ""
                                      : "bordererror"
                            }
                            onClick={(e) => {
                              handleDescribeSelect(
                                  "tab3",
                                  t("education-paraprofessional")
                              );
                              setIsSelect("");
                            }}
                        >
                          <div>
                            <img
                                src={
                                  describe &&
                                  describe.tab3 == t("education-paraprofessional")
                                      ? "./images/education_fill.svg"
                                      : "./images/education.svg"
                                }
                            />
                            <span>{t("education-paraprofessional")}</span>
                          </div>
                        </li>
                        <li
                            className={
                              describe && describe.tab4 == t("text-tutor")
                                  ? "active"
                                  : "" + isSelect == ""
                                      ? ""
                                      : "bordererror"
                            }
                            onClick={(e) => {
                              handleDescribeSelect("tab4", t("text-tutor"));
                              setIsSelect("");
                            }}
                        >
                          <div>
                            <img
                                src={
                                  describe && describe.tab4 == t("text-tutor")
                                      ? "./images/tutor_fill.svg"
                                      : "./images/tutor.svg"
                                }
                            />
                            <span>{t("text-tutor")}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <button className="back_sign" onClick={handleRedirect}>
                      {t("text-back")}
                    </button>
                    <button
                        onClick={(e) => {
                          Object.keys(describe).length >= 1
                              ? setStep("stap3")
                              : setIsSelect("Please select your needs.");
                        }}
                    >
                      {t("text-next")}
                    </button>
                  </div>

                  <div
                      className={
                          "describe more_about form_signup " +
                          (step == "stap3" ? "" : "none")
                      }
                  >
                    <img src="/images/sign_logo.svg" />
                    <h2>{t("Tell us more about yourself")}</h2>

                    <ProviderSignupForm
                        today={today}
                        handleShowModal={handleShowModal}
                        handleCodeSelect={handleCodeSelect}
                        contactCode={contactCode}
                        code={code}
                        setContactCode={setContactCode}
                        setLangLong={setLatLong}
                    />

                    <p style={{
                      marginTop: "8px"
                    }}>
                      {t("By clicking on “Sign up” you agree to our")}
                      <Link to="/terms-of-use" target={"_blank"}>
                        {t("Terms of Use")}
                      </Link>
                      {t("text-and")}
                      <Link to="/privacy-policy" target={"_blank"}>
                        {t("Privacy Policy")}
                      </Link>
                      .
                    </p>
                    <button className="back_sign" onClick={(e) => setStep("stap2")}>
                      {t("text-back")}
                    </button>
                    <button
                        onClick={() => {
                          handleSignup();
                        }}
                    >
                      <Link to="/signup_provider">{t("sign-up")}</Link>
                    </button>
                  </div>
                  <div
                      className={
                          "signupdetail " +
                          (step == "stap2" || step == "stap2" || step == "stap3"
                              ? ""
                              : "none")
                      }
                  >
                    <h2>
                      {t("sign-up")} <br /> {t("for FREE!")}
                    </h2>
                    <ul>
                      <li>
                        <img src="./images/thanks_right.svg" />
                        <span>{t("Create your profile.")}</span>
                      </li>
                      <li>
                        <img src="./images/thanks_right.svg" />
                        <span>{t("Browse and apply for child services jobs.")}</span>
                      </li>
                      <li>
                        <img src="./images/thanks_right.svg" />
                        <span>{t("Connect with schools and families.")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
        </div>
      </div>

      {showModal && (
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="promocode_content younger">
              <Link to="/signup_provider" onClick={handleCloseModal}>
                +
              </Link>
              <h5>{t("Thank you!")}</h5>
              <p>{t("post-about-persons-younder")}</p>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
